import {
  HealthCheckApi,
  HealthcheckHealthCheckStrategyReq,
  HealthcheckTriggerHealthCheckReq
} from '@clinic/client'
import { axiosInstance } from '~/api/base'

const basePath = '/clinic/api/v1'
const healthCheckApi = new HealthCheckApi(undefined, basePath, axiosInstance)

function getCsrfToken() {
  return ''
}

// Strategy
export function listStrategies(
  oid: string,
  cid: string,
  page?: number,
  limit?: number
) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyGet(
    getCsrfToken(),
    oid,
    cid,
    page,
    limit
  )
}

export function createStrategy(
  oid: string,
  cid: string,
  strategy: HealthcheckHealthCheckStrategyReq
) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyPost(
    getCsrfToken(),
    oid,
    cid,
    strategy
  )
}

export function getStrategy(oid: string, cid: string, uuid: string) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyUuidGet(
    getCsrfToken(),
    oid,
    cid,
    uuid
  )
}

export function updateStrategy(
  oid: string,
  cid: string,
  uuid: string,
  strategy: HealthcheckHealthCheckStrategyReq
) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyUuidPut(
    getCsrfToken(),
    oid,
    cid,
    uuid,
    strategy
  )
}

export function deleteStrategy(oid: string, cid: string, uuid: string) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyUuidDelete(
    getCsrfToken(),
    oid,
    cid,
    uuid
  )
}

// Trigger
export function triggerHealthCheck(
  oid: string,
  cid: string,
  strategyUuid: string,
  trigger?: HealthcheckTriggerHealthCheckReq
) {
  return healthCheckApi.computeEngineOidCidHealthcheckStrategyUuidTriggerPost(
    getCsrfToken(),
    oid,
    cid,
    strategyUuid,
    trigger
  )
}

// Results
export function listResults(
  oid: string,
  cid: string,
  page?: number,
  limit?: number
) {
  return healthCheckApi.computeEngineOidCidHealthcheckResultGet(
    getCsrfToken(),
    oid,
    cid,
    page,
    limit
  )
}

export function getResultDetail(oid: string, cid: string, uuid: string) {
  return healthCheckApi.computeEngineOidCidHealthcheckResultUuidGet(
    getCsrfToken(),
    oid,
    cid,
    uuid
  )
}

export function deleteResult(oid: string, cid: string, uuid: string) {
  return healthCheckApi.computeEngineOidCidHealthcheckResultUuidDelete(
    getCsrfToken(),
    oid,
    cid,
    uuid
  )
}
